/**
 * Applies `profile.preferred_language` to the chrome once the signed-in
 * profile arrives (docs/TRANSLATION_SPEC.md §13). Mounted once, renders
 * nothing.
 *
 * The profile outranks `localStorage` and the browser: a family that told us
 * their language in onboarding, in Account settings or on another device
 * should not have to tell this device again. A tag we have no catalog for
 * (say `pt-BR`, which content translation does support) collapses to English
 * chrome — `resolveUiLanguage` decides that, not this component.
 */
import { useEffect } from 'react';
import { useUser } from '../contexts/UserContextNew';
import { activeUiLanguage, resolveUiLanguage, setUiLanguage } from '../i18n';

export function LanguageSync() {
  const { userProfile } = useUser();
  const preferred = userProfile?.preferred_language;

  useEffect(() => {
    if (!preferred) return;
    const next = resolveUiLanguage(preferred);
    if (next === activeUiLanguage()) return;
    void setUiLanguage(next);
  }, [preferred]);

  return null;
}

export default LanguageSync;
